export default __webpack_public_path__ + "static/media/h5-bg1.dc5c5ec0.png";